import { ACCOUNT_TYPES, useAccountsStore } from '@/entities/account';
import {
  useAssets,
  useAssetsIcons,
  useDepositWithdrawAssetsDictionary,
} from '@/shared/api';

export function useWithdrawOperationData() {
  const { ewallet } = useAccountsStore();
  const { assetsIconsData } = useAssetsIcons();
  const {
    depositWithdrawAssetsData,
    depositWithdrawAssetsLoading,
    depositWithdrawAssetsIsError,
    depositWithdrawAssetsError,
  } = useDepositWithdrawAssetsDictionary();

  const { data: assetsData } = useAssets({
    enabled: !!depositWithdrawAssetsData,
  });

  const mainAccount = ewallet?.accounts?.find(
    acc => acc.accTypeName === ACCOUNT_TYPES.Main
  );

  return {
    assetsIconsData,
    depositWithdrawAssetsLoading,
    depositWithdrawAssetsIsError,
    depositWithdrawAssetsError,
    depositWithdrawAssetsData,
    assetsData,
    mainAccount,
    ewallet,
  };
}
